import React, { useEffect } from "react";

const AboutUs = () => {
  useEffect(() => {
    document.body.className = "about-page";
    return () => {
      document.body.className = "";
    };
  }, []);

  const team = [
    {
      name: "Vedant Singh",
      role: "Lead Backend Architect",
      icon: "fa-server",
      color: "#6a11cb",
    },
    {
      name: "Krishna Sikarwar",
      role: "Frontend Developer",
      icon: "fa-code",
      color: "#e91e63",
    },
    {
      name: "Riya Singh",
      role: "Frontend Developer",
      icon: "fa-laptop-code",
      color: "#2196f3",
    },
  ];

  return (
    <main
      style={{ background: "#ffffff", color: "#2d3436", paddingBottom: "5rem" }}
    >
      {/* 🚀 Hero Section */}
      <section
        style={{
          padding: "5rem 1rem",
          textAlign: "center",
          background: "linear-gradient(180deg, #fff0f5 0%, #ffffff 100%)",
          borderBottom: "1px solid #f1f1f1",
        }}
      >
        <div className="container">
          <h1
            style={{
              fontSize: "3.5rem",
              fontWeight: "800",
              marginBottom: "1rem",
            }}
          >
            About <span style={{ color: "#e91e63" }}>FloraCare</span>
          </h1>
          <p
            style={{
              fontSize: "1.2rem",
              color: "#636e72",
              maxWidth: "700px",
              margin: "0 auto",
              lineHeight: "1.6",
            }}
          >
            Redefining women's health through AI-driven insights and secure,
            integrated care solutions.
          </p>
        </div>
      </section>

      <div className="container" style={{ marginTop: "4rem" }}>
        {/* 📖 The Mission */}
        <div
          style={{
            maxWidth: "800px",
            margin: "0 auto 6rem",
            textAlign: "center",
          }}
        >
          <h2 style={{ fontSize: "2.2rem", marginBottom: "1.5rem" }}>
            Our Vision
          </h2>
          <p
            style={{ color: "#636e72", lineHeight: "1.8", fontSize: "1.1rem" }}
          >
            FloraCare was designed to simplify the complex journey of
            reproductive health and early parenthood. By combining **GyneCare**
            and **BabyCare** into one unified platform, we provide our users
            with the tools they need to stay informed and healthy at every
            stage.
          </p>
        </div>

        <hr
          style={{
            border: "0",
            borderTop: "1px solid #eee",
            marginBottom: "5rem",
          }}
        />

        {/* 👥 Meet the Team */}
        <h2
          style={{
            textAlign: "center",
            marginBottom: "3.5rem",
            fontSize: "2.5rem",
            fontWeight: "800",
          }}
        >
          The Engineering Team
        </h2>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "2.5rem",
            flexWrap: "wrap",
            padding: "0 1rem",
          }}
        >
          {team.map((member, index) => (
            <div
              key={index}
              style={{
                background: "#fff",
                flex: "1",
                minWidth: "280px",
                maxWidth: "320px",
                textAlign: "center",
                padding: "3.5rem 2rem",
                borderRadius: "30px",
                boxShadow: "0 15px 35px rgba(0,0,0,0.05)",
                border: "1px solid #f8f9fa",
                transition: "all 0.3s ease",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "translateY(-10px)";
                e.currentTarget.style.borderColor = member.color;
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.borderColor = "#f8f9fa";
              }}
            >
              <div
                style={{
                  color: member.color,
                  background: `${member.color}10`,
                  width: "90px",
                  height: "90px",
                  borderRadius: "25px",
                  margin: "0 auto 1.5rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i
                  className={`fas ${member.icon}`}
                  style={{ fontSize: "2.5rem" }}
                ></i>
              </div>

              <h3
                style={{
                  fontSize: "1.5rem",
                  marginBottom: "0.5rem",
                  color: "#2d3436",
                }}
              >
                {member.name}
              </h3>
              <p
                style={{
                  color: member.color,
                  fontWeight: "700",
                  textTransform: "uppercase",
                  fontSize: "0.85rem",
                  letterSpacing: "1.5px",
                  margin: 0,
                }}
              >
                {member.role}
              </p>

              <div
                style={{
                  marginTop: "2rem",
                  display: "flex",
                  justifyContent: "center",
                  gap: "20px",
                  color: "#cbd5e0",
                }}
              >
                <i
                  className="fab fa-github"
                  style={{ cursor: "pointer", fontSize: "1.2rem" }}
                ></i>
                <i
                  className="fab fa-linkedin"
                  style={{ cursor: "pointer", fontSize: "1.2rem" }}
                ></i>
              </div>
            </div>
          ))}
        </div>

        {/* 🛡️ Values Section */}
        <div
          style={{
            marginTop: "7rem",
            padding: "4rem 2rem",
            background: "#fcfcfc",
            borderRadius: "40px",
            textAlign: "center",
            border: "1px solid #f1f1f1",
          }}
        >
          <h2 style={{ marginBottom: "2.5rem" }}>Built with Integrity</h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
              gap: "2rem",
            }}
          >
            <div>
              <i
                className="fas fa-user-lock"
                style={{
                  color: "#6a11cb",
                  fontSize: "1.5rem",
                  marginBottom: "1rem",
                }}
              ></i>
              <h4 style={{ marginBottom: "0.5rem" }}>Data Privacy</h4>
              <p style={{ fontSize: "0.9rem", color: "#666" }}>
                Secure backend architecture designed for ultimate safety.
              </p>
            </div>
            <div>
              <i
                className="fas fa-heart"
                style={{
                  color: "#e91e63",
                  fontSize: "1.5rem",
                  marginBottom: "1rem",
                }}
              ></i>
              <h4 style={{ marginBottom: "0.5rem" }}>User Centric</h4>
              <p style={{ fontSize: "0.9rem", color: "#666" }}>
                Built with empathy to handle sensitive health information.
              </p>
            </div>
            <div>
              <i
                className="fas fa-microchip"
                style={{
                  color: "#2196f3",
                  fontSize: "1.5rem",
                  marginBottom: "1rem",
                }}
              ></i>
              <h4 style={{ marginBottom: "0.5rem" }}>Smart Logic</h4>
              <p style={{ fontSize: "0.9rem", color: "#666" }}>
                Efficient API systems and intelligent health predictions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default AboutUs;
